import { render, staticRenderFns } from "./ActivityAddress.vue?vue&type=template&id=472d4d62&scoped=true"
import script from "./ActivityAddress.vue?vue&type=script&lang=js"
export * from "./ActivityAddress.vue?vue&type=script&lang=js"
import style0 from "./ActivityAddress.vue?vue&type=style&index=0&id=472d4d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d4d62",
  null
  
)

export default component.exports